<template>
	<section class="awaiting-bonus-sec">
		<div class="pending-bonus-transfer-sec open-bets-wrapper">
			<div class="remove-padding">
				<div class="awaitning-back-btn">
					<a @click="$router.back()" title="Go Back" role="button" href="javascript:void(0)">
                        <i class="fa-solid fa-angle-left"></i>
                    </a>
                    <span>{{ $t('my-transactions','My Transactions')}}</span>
                </div>
			</div>
		</div>
	</section>

    <section class="profit-loss-v-container open-bet-wrapper" loading="lazy">
        <div class="remove-padding">
            <div class="bonus-start-end-date profit-loss">
                <div class="row g-2">
                    <div class="col-6 col-sm-6 col-md-3 col-lg-3">
                        <div class="bonus-v-input select-date">
                            <span class="form-label">{{ $t('from-date-title', 'From Date') }} :</span>
                            <input v-model="formDates.fromDate" @input="preventClearFromDate" class="form-control" type="date" required>
                        </div>
                    </div>
                    <div class="col-6 col-sm-6 col-md-3 col-lg-3">
                        <div class="bonus-v-input select-date">
                            <span class="form-label">{{ $t('to-date-title', 'To Date') }} :</span>
                            <input v-model="formDates.toDate" class="form-control" @input="preventClearToDate" type="date" required>
                        </div>
                    </div>
                    <div class="col-6 col-sm-6 col-md-3 col-lg-3">
                        <div class="bonus-v-input game-selct-menu-list"> <span class="form-label">{{ $t('type', 'Type') }} :</span>
                            <select class="form-select" v-model="selectedStatus" aria-label="Default select example">
                                <option v-for="item in options" :key="item.value" :value="item.value">
                                    {{ $t(item.label?.toLowerCase(), item.label) }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-6 col-sm-6 col-md-3 col-lg-3">
                        <div class="bonus-v-apply-btn s-btn">
                            <button class="button" @click="getWalletHistory(true)">{{ $t('apply', 'Apply') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

	<section class="transactions-details-tabs transection_body_sec">
		<div class="trans-history-tabs-h">
			<ul class="nav nav-pills" id="pills-tab" role="tablist">
				<li class="nav-item" role="presentation">
					<button class="nav-link active" id="deposit-tab-tab" data-bs-toggle="pill" @click="selectedTransactionType = 'deposit'" data-bs-target="#deposit-tab" type="button" 
                        role="tab" aria-controls="deposit-tab" aria-selected="true">
                        {{ $t('deposit', 'deposit') }}
                    </button>
				</li>
				<li class="nav-item" role="presentation">
					<button class="nav-link" id="deposit-tab-tab" data-bs-toggle="pill" @click="selectedTransactionType = 'withdraw'" data-bs-target="#deposit-tab" type="button" 
                        role="tab" aria-controls="deposit-tab" aria-selected="false">
                        {{ $t('withdraw', 'withdraw') }}
                    </button>
				</li>
			</ul>
		</div>
		<div class="tab-content" id="pills-tabContent">
			<div class="tab-pane fade show active" id="deposit-tab" role="tabpanel" aria-labelledby="deposit-tab-tab">
                <template v-if="filteredData && filteredData.length > 0">
                    <div class="trans-rapper transitation_body" v-for="(item, index) in filteredData" :key="index">
                        <div class="trns-cmn-h">
                            <div class="lft-amonunt-h">
                                <span>{{ $t('amount','Amount')}}:</span> <span class="amont-text-color">{{ item.amount }}</span>
                            </div>
                            <div class="rgt-status-h">
                                <span>{{ $t('status', 'Status') }} : </span>
                                <span :class="getTransactionStatus(item.status).class">
                                    {{ getTransactionStatus(item.status).label }}
                                    <button class="relode_item bg-black" type="button" @click.stop="handleRefreshWalletHistory(index)" :id="'spin'+index" 
                                    v-if="['pending', 'approve_in_process', 'reject_in_process','hold'].includes(item.status)">
                                        <img src="@/assets/images/relode.svg" alt="relode"/>
                                    </button>
                                </span>
                            </div>
                        </div>
                        <div class="trans-req-body tran_gateway">
                            <ul>
                                <li> 
                                    <div class="tran_req_row1">
                                        <strong>{{ $t('payment-type', 'Payment Type') }}</strong>
                                    </div> 
                                    <div>:</div>
                                    <div class="tran_req_row2">
                                        {{toTitleCaseWithSpaces(item?.type)}}
                                    </div>
                                </li>
                                <li> 
                                    <div class="tran_req_row1">
                                        <strong>{{ $t('payment-type', 'Payment Method') }}</strong>
                                    </div> 
                                    <div>:</div>
                                    <div class="tran_req_row2">
                                        {{item?.payment_method ||'-'}}
                                    </div>
                                </li>
                                <li> 
                                    <div class="tran_req_row1">
                                        <strong>Approved Amount</strong>
                                    </div> 
                                    <div>:</div>
                                    <div class="tran_req_row2">
                                        {{ item?.approved_amount || '-' }}
                                    </div>
                                </li>
                                <li> 
                                    <div class="tran_req_row1">
                                        <strong>{{ $t('request-date', 'Request Date') }} </strong>
                                    </div> 
                                    <div>:</div>
                                    <div class="tran_req_row2">
                                        {{ $dateTime.getLocalDate(item?.created_at, 'DD/MM/YYYY hh:mm:ss A') }}
                                    </div>
                                </li>
                                <li> 
                                    <div class="tran_req_row1">
                                        <strong>{{ $t('transaction-no', 'Transaction No') }}</strong> 
                                    </div> 
                                    <div>:</div>
                                    <div class="tran_req_row2">
                                        {{ item?.transaction_id }}
                                    </div>
                                 </li>
                                <li> 
                                    <div class="tran_req_row1">
                                        <strong>Action</strong>
                                    </div> 
                                    <div>:</div>
                                    <div class="tran_req_row2" v-if="item.status == 'pending'">-</div>
                                    <div class="tran_req_row2" v-else-if="item.status == 'hold'">{{ item?.hold_at ? $dateTime.getLocalDate(item?.hold_at, 'DD/MM/YYYY hh:mm:ss A') : '-'}}</div>
                                    <div class="tran_req_row2" v-else>{{ item?.action_at ? $dateTime.getLocalDate(item?.action_at, 'DD/MM/YYYY hh:mm:ss A') : '-'}}</div>
                                </li>
                                <li> 
                                    <div class="tran_req_row1">
                                        <strong>Attachment</strong>
                                    </div> 
                                    <div>:</div>
                                    <div class="tran_req_row2" >
                                        <div class="view-details" v-if="item?.transaction_image_url">
                                            <button type="button" class="thm-but back_btn_link" @click="currentImgUrl = item?.transaction_image_url" data-bs-toggle="modal" data-bs-target="#transactionModal">{{ $t('view-details','View details') }}</button>
                                        </div>
                                        <div v-else>-</div>
                                    </div>
                                </li>

                                <li class="tran_hr_div" @click="toggleComments(index)">
                                    <div class="tran_req_row1">
                                        <strong>{{ $t('reason', 'Reason') }}</strong>
                                    </div> 
                                    <div class="tran_req_row2 text-end">
                                        <i class="fa-solid fa-angles-down arrow_down" :class="{ rotate: showComments[index] }"></i>
                                    </div>
                                </li>

                                <transition name="slide-fade">
                                    <div v-if="showComments[index]" class="trans_comments_box">
                                        <div class="v_card_subtitle">
                                            <span>{{ item.remark || '-' }}</span>
                                            
                                        </div>
                                    </div>
                                </transition>
                            </ul>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <NoDataFound></NoDataFound>
                </template>
			</div>
		</div>
	</section>
    <!-- transaction details modal -->
    <div class="modal fade history-filter-modal transaction_detail_modal" id="transactionModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
         <div class="modal-content">
            <div class="modal-header">
               <div class="thm-heading">
                  <h3>{{ $t('details','Details') }}</h3>
               </div>
               <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
               <div v-if="currentImgUrl">
                  <div class="row my-2" style="align-items: center;" >
                     <div class="col-12 text-center qrPreview-image" v-if="currentImgUrl">
                           <div v-for="(item,index) in transactionImageLists" :key="index" class="transactionImage-item">
                                <a :href="item" target="_blank">
                                    <img :src="item" alt="Preview" height="100%" width="100px" />
                                </a>
                           </div>
                     </div> <br>
                  </div>
               </div>
               <div v-else>
                  <p class="text-center" style="color: #000;">{{ $t('no-record-found','No Record found') }}</p>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import moment from 'moment-timezone';
import { defineAsyncComponent } from 'vue';
import {getWalletHistory, getTransactionStatus} from '../services/walletHistory'
import NoDataFound from '@/shared/components/no-data/NoDataFound.vue';

export default {
    name:'Transactions',
    data(){
        return{
            walletHistoryData:[],
            formDates:{
                fromDate: '',
                toDate: '',
            },
            statusData:'all',
            totalPage: null,
            pageEntries: 25,
            selectedStatus: 'all',
            options: [
                { label: this.$t('all', 'All'), value: 'all', selected:true },
                { label: this.$t('pending', 'Pending'), value: 'pending', selected:true },
                { label: this.$t('approved', 'Approved'), value: 'approve_completed', selected:true },
                { label: this.$t('rejected', 'Rejected'), value: 'reject_completed', selected:true },
                { label: this.$t('processing', 'Processing'), value: 'processing', selected:true },
                { label: this.$t('expired', 'Expired'), value: 'expired', selected:true },
                
            ],
            showComments: {},
            selectedTransactionType: 'deposit',
            currentImgUrl:'',
        }
    },
    components: {
		NoDataFound,
    },
    created(){
        this.formDates.fromDate = this.$dateTime.getPreviousDate(2);
        this.formDates.toDate = this.$dateTime.getcurrentDate();  
        this.getWalletHistory();
    },
    computed: {
        transactionImageLists() {
            return this.currentImgUrl?.split(',')
        },
        filteredData(){
            let data = this.walletHistoryData
            if(this.selectedTransactionType == 'deposit'){
                data = data.filter((history) => ['client_deposit','manual_deposit'].includes(history.type))
            }
            else if(this.selectedTransactionType == 'withdraw'){
                data = data.filter((history) => ['client_withdrawal','manual_withdrawal'].includes(history.type))
            }
            return data;
        },
        walletDeposit() {
            return this.walletHistoryData?.filter(item => item.type == 2);
        },
        walletWithdraw() {
            return this.walletHistoryData?.filter(item => item.type == 3);
        }
    },
    methods:{
        handleRefreshWalletHistory(index) {
            let spinElem = document.getElementById('spin'+index)
            spinElem.classList.add('refresh-spin')
            const spinTimeout = setTimeout(() => {
                spinElem.classList.remove('refresh-spin')
                clearTimeout(spinTimeout);
            }, 2000);
            this.getWalletHistory()
        },
        toTitleCaseWithSpaces(str) {
            return str.split('_')[0] + ' ' + str.split('_')[1] ;
        },
        getTransactionStatus,
        toggleComments(index) {
            this.showComments = { [index]: !this.showComments[index] };
        },
        async getWalletHistory() {
                try{
                if (!this.validateDateFields()) {
                    return; 
                }
                this.statusData = this.selectedStatus;
                this.$store.dispatch('setGlobalLoader', true);
                let response = await getWalletHistory(this.formDates)
                this.$store.dispatch('setGlobalLoader', false);
                if(response){
                    this.walletHistoryData = response?.walletHistoryData || [];
                    if(this.selectedStatus == 'all'){
                        this.walletHistoryData = this.walletHistoryData;
                    }
                    else if(this.selectedStatus == 'processing'){
                        this.walletHistoryData = this.walletHistoryData?.filter((history) => ['reject_in_process','approve_in_process','hold'].includes(history.status))
                    }
                    else if(!['all', 'processing'].includes(this.selectedStatus)){
                        this.walletHistoryData = this.walletHistoryData?.filter((history) => history.status == this.selectedStatus)
                    }
                }
            }catch(error) {
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    this.$errorToast(error[0]);
                }
            };
        },
        validateDateFields() {
            const { fromDate, toDate } = this.formDates;
            if (!fromDate || !toDate) {
                if (!fromDate && !toDate) {
                    this.$errorToast("From and To Date Field Is Required.");
                } else if (!fromDate) {
                    this.$errorToast("From Date Field Is Required.");
                } else {
                    this.$errorToast("To Date Field Is Required.");
                }
                return false;
            }
            return true;
        },
        convertDateInUtcStartingDate(date = ''){
            if(date){
                var dateToConvert = date;
                var convertedDate = moment.tz(dateToConvert, moment.tz.guess());
                var startOfDay  = convertedDate.startOf('day');
                var startOfDayUTC = startOfDay.clone().utc();
                var formattedStartTime = startOfDayUTC.format('YYYY-MM-DD hh:mm:ss A');
                return formattedStartTime;
            }
        },
        convertDateInUtcEndDate(date = ''){
            if(date){
                var dateToConvert = date;
                var convertedDate = moment.tz(dateToConvert, moment.tz.guess());
                var endOfDay = convertedDate.endOf('day');
                var endOfDayUTC = endOfDay.clone().utc();
                var formattedEndTime = endOfDayUTC.format('YYYY-MM-DD hh:mm:ss A');
                return formattedEndTime;
            }
        },
        preventClearFromDate(event) {
            if (!event.target.value) {
            this.formDates.fromDate = this.$dateTime.getDateSaperatedByDays(2); 
            }
        },
        preventClearToDate(event) {
            if (!event.target.value) {
            this.formDates.toDate = this.$dateTime.getcurrentDate();
            }
        }
    }
}
</script>